module.exports = __webpack_public_path__ + "img/fm-f-Path 56 Copy@3x.f2194c9c.png";